import Swiper, {Pagination, Navigation, Autoplay} from 'swiper';
import {GetRecipeCategories} from 'Apis/apis';

Swiper.use([Pagination, Navigation, Autoplay]);
import * as balanceText from 'Lib/balanceText.js';

export namespace RecipeCarousel {
	let setupSlider = () => {

		let heroSliders = document.querySelectorAll('.js-recipe-carousel');

		//For Each Hero Slider Loop through and setup swiper
		heroSliders.forEach((slider, index) => {
			slider.classList.add(`recipe-carousel--${index}`);
			const swiper = new Swiper(`.recipe-carousel--${index}`, {
				slidesPerView: 1,
				spaceBetween: 0,

				// Navigation arrows
				navigation: {
					nextEl: `.recipe-carousel--${index} .swiper-button-next`,
					prevEl: `.recipe-carousel--${index} .swiper-button-prev`,
				},

				breakpoints: {
					0: {
						slidesPerView: 1,
						spaceBetween: 0,
					},
					500: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					768: {
						slidesPerView: 3,
						spaceBetween: 20,
					},
					1024: {
						slidesPerView: 4,
						spaceBetween: 20,
					},
					1280: {
						slidesPerView: 5,
						spaceBetween: 20,
					}
				},


				on: {
					init: function () {
						balanceText();
					},
				}
			});
		});
	}

	let getCategories = () => {
		let categories = document.querySelectorAll('.js-category');
		let categoryArray = [];

		categories.forEach(async (category) => {
			let taxId = category.getAttribute('data-tax-id');
			let categoryData = await GetRecipeCategories(taxId);
			categoryArray.push(categoryData);
		});
	}


	export const init = () => {
		setupSlider();
		getCategories();
	}
}


document.addEventListener('DOMContentLoaded', RecipeCarousel.init);
